import React from "react";
import Form from "react-bootstrap/Form";

interface Option {
  value: string | number;
  label: string | number;
}

interface SelectProps {
  name?: string;
  title?: string;
  options: Option[];
  showBorder?: boolean;
  showFirstOption?: boolean;
  value?: string | number;
  onChange?: (e: any) => void;
  onClick?: (e: any) => void;
}

const Select: React.FC<SelectProps> = ({
  name,
  title,
  options,
  showBorder = true,
  showFirstOption = true,
  value,
  onChange,
  onClick,
}) => {
  return (
    <Form.Select
      name={name}
      className={`${showBorder ? "selectBorder" : "border-0"}`}
      value={value}
      onChange={onChange}
      onClick={onClick}
    >
      {showFirstOption && (
        <option value="" disabled={false} hidden={false}>
          {title}
        </option>
      )}
      {options.map((option, index) => (
        <option
          key={index}
          value={option?.value}
          // selected={option?.value === value}
        >
          {option?.label}
        </option>
      ))}
    </Form.Select>
  );
};

export default Select;
